import { useMutation, useQueryClient } from '@tanstack/react-query';
import { queryKeys, pluginsService } from '@v2/services';

export const useAddPluginToOffering = () => {
  const queryClient = useQueryClient();

  const mutation = useMutation({
    mutationFn: ({
      offeringName,
      pluginId,
    }: {
      offeringName: string;
      pluginId: string;
    }) => pluginsService.addPluginToOffering(offeringName, pluginId),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(
        queryKeys.plugins.byOffering(variables.offeringName)
      );
    },
  });

  const addPluginToOffering = async (
    offeringName: string,
    pluginId: string
  ): Promise<string | null> => {
    try {
      return await mutation.mutateAsync({ offeringName, pluginId });
    } catch {
      return null;
    }
  };

  return {
    addPluginToOffering,
    loading: mutation.isLoading,
    error: mutation.error instanceof Error ? mutation.error.message : null,
  };
};

export default useAddPluginToOffering;
